import React from 'react';
import { Primitive } from '@mirohq-internal/design-system-primitive';
import { styled, theme } from '@mirohq-internal/design-system-stitches';
import { createConstants, mapKeysToVariants } from '@mirohq-internal/design-system-utils';

const SIZES$1 = createConstants(1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12);
const StyledGrid = styled(Primitive.div, {
  display: "grid",
  variants: {
    align: {
      start: {
        alignItems: "start"
      },
      center: {
        alignItems: "center"
      },
      end: {
        alignItems: "end"
      },
      stretch: {
        alignItems: "stretch"
      },
      baseline: {
        alignItems: "baseline"
      }
    },
    flow: {
      row: {
        gridAutoFlow: "row"
      },
      column: {
        gridAutoFlow: "column"
      },
      dense: {
        gridAutoFlow: "dense"
      },
      rowDense: {
        gridAutoFlow: "row dense"
      },
      columnDense: {
        gridAutoFlow: "column dense"
      }
    },
    gap: mapKeysToVariants(theme["space-gap"], "gap"),
    gapX: mapKeysToVariants(theme["space-gap"], "rowGap"),
    gapY: mapKeysToVariants(theme["space-gap"], "columnGap"),
    columns: mapKeysToVariants(SIZES$1, (key) => ({
      gridTemplateColumns: `repeat(${key}, 1fr)`
    })),
    rows: mapKeysToVariants(SIZES$1, (key) => ({
      gridTemplateRows: `repeat(${key}, 1fr)`
    })),
    justify: {
      start: {
        justifyContent: "start"
      },
      center: {
        justifyContent: "center"
      },
      end: {
        justifyContent: "end"
      },
      stretch: {
        justifyContent: "stretch"
      },
      between: {
        justifyContent: "space-between"
      },
      around: {
        justifyContent: "space-around"
      },
      evenly: {
        justifyContent: "space-evenly"
      }
    },
    justifyItems: {
      start: {
        justifyItems: "start"
      },
      center: {
        justifyItems: "center"
      },
      end: {
        justifyItems: "end"
      },
      stretch: {
        justifyItems: "stretch"
      }
    }
  }
});

const ADDITIONAL_COLUMNS_ROWS_SIZES = createConstants(-1);
const SIZES = { ...ADDITIONAL_COLUMNS_ROWS_SIZES, ...SIZES$1 };
const StyledItem = styled(Primitive.div, {
  variants: {
    columnStart: mapKeysToVariants(SIZES, (key) => ({ gridColumnStart: key })),
    rowStart: mapKeysToVariants(SIZES, (key) => ({ gridRowStart: key })),
    columnEnd: mapKeysToVariants(SIZES, (key) => ({ gridColumnEnd: key })),
    rowEnd: mapKeysToVariants(SIZES, (key) => ({ gridRowEnd: key }))
  }
});

const Item = React.forwardRef(
  (props, forwardRef) => /* @__PURE__ */ React.createElement(StyledItem, {
    ...props,
    ref: forwardRef
  })
);

const Grid = React.forwardRef(
  (props, forwardRef) => /* @__PURE__ */ React.createElement(StyledGrid, {
    ...props,
    ref: forwardRef
  })
);
Grid.Item = Item;

export { Grid };
//# sourceMappingURL=module.js.map
